import React, { useMemo } from "react";
import { Box, BoxProps } from "@bookingcom/bui-react";
import { SOUTHWEST_PHOTOS } from "../../../../constants";

// flights_web_southwest
export default function SearchLoadingSouthwest() {
  const attributes = useMemo<BoxProps["attributes"]>(
    () => ({
      style: {
        height: "100%",
        backgroundImage: `url(${SOUTHWEST_PHOTOS.artwork})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
      }
    }),
    []
  );

  return <Box attributes={attributes} />;
}
